import { RELAY_MODULE_STATUS_CONNECTED } from '../pages/devices/tabs/relay/relay';

export function getStatusTranslation(
  status: string | undefined,
  t: Function
): string {
  return status === RELAY_MODULE_STATUS_CONNECTED
    ? t('web.admin.hardware.management.relay.status.active')
    : t('web.admin.hardware.management.relay.status.offline');
}